var map = {
	"./arrow_bottom_left.svg": 194,
	"./arrow_bottom_right.svg": 73,
	"./arrow_left_bottom.svg": 65,
	"./arrow_left_top.svg": 390,
	"./arrow_right_bottom.svg": 885,
	"./arrow_right_top.svg": 479,
	"./arrow_top_left.svg": 221,
	"./arrow_top_right.svg": 498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;